import React, { FC } from 'react';
import Link from 'ati-ui-react/components/Link';
import useMiniCard from 'hooks/useMiniCard';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { OwnerInfoStyles } from './OwnerInfoStyles';

const OwnerInfo: FC = observer(() => {
  const {
    appStore: { isDesktop },
  } = useStores();

  const {
    data: {
      account: { firmName, fullFirmName, linkToPassport },
    },
  } = useMiniCard();

  const displayFirmName = isDesktop ? fullFirmName : firmName;

  return (
    <OwnerInfoStyles onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
      <Link href={linkToPassport} small target="_blank">
        {displayFirmName}
      </Link>
    </OwnerInfoStyles>
  );
});

export default OwnerInfo;
